var util_functions = {
  is_admin(user_details) {
    if (user_details.super_admin || user_details.admin) {
      return true;
    }
    return false;
  },

  is_admin_or_support(user_details) {
    if (
      user_details.super_admin ||
      user_details.admin ||
      user_details.support_accounts
    ) {
      return true;
    }
    return false;
  },

  is_super_or_support(user_details) {
    if (user_details.super_admin || user_details.support_accounts) {
      return true;
    }
    return false;
  },

  is_supported_account(account, user_details) {
    if (
      user_details.support_accounts &&
      user_details.support_accounts.includes(account)
    ) {
      return true;
    }
    return false;
  },
};

export default util_functions;
